export default __webpack_public_path__ + "static/media/Nexus-1718803732488.fd141876.png";